// third-party
import { createSlice } from '@reduxjs/toolkit';
// project imports
import axios from '../../utils/axios';
import utils from '../../utils/utils';
import { dispatch } from '../index';

const initialState = {
    gyms: [],
    error: null,
    totalPages: 1,
    loading: false,
    limit: 10,
    currentPage: 1
};

// Reducer
const slice = createSlice({
    name: 'gyms',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },

        startLoading(state, action) {
            state.loading = true;
        },
        stopLoading(state, action) {
            state.loading = false;
        },

        // GET USERS STYLE 1
        getSuccess(state, action) {
            state.gyms = utils.sortAlphatically(action.payload, 'name');
            const total = action.payload.length;
            let pages = Math.floor(total / state.limit);
            const remainder = total % state.limit;
            if (remainder !== 0) {
                pages += 1;
            }
            state.totalPages = pages;
            state.loading = false;
        },

        addSuccess(state, action) {
            state.loading = false;
        },

        deleteSuccess(state, action) {
            state.loading = false;
        },

        editSuccess(state, action) {
            state.loading = false;
        },

        setCurrentPage(state, action) {
            console.log(action.payload);
            state.currentPage = action.payload;
        }
    }
});

export default slice.reducer;

// Actions
export function startLoading() {
    return async () => {
        dispatch(slice.actions.startLoading());
    };
}

export function stopLoading() {
    return async () => {
        dispatch(slice.actions.stopLoading());
    };
}


export function addGym(data, callback = () => {}, errcallback = () => {}) {
    return async () => {
        try {
            const result = await axios.post(`/gyms`, data);
            console.log('RES [addGym] ======> ', result.data.data);
            dispatch(slice.actions.addSuccess(result.data.data));
            callback();
        } catch (error) {
            console.log('ERR [addGym] =======> ', error);
            dispatch(slice.actions.hasError(error));
            errcallback();
        }
    };
}

export function deleteGym(id = '', callback = () => {}, errcallback = () => {}) {
    const URL = `/gyms/${id}`;
    return async () => {
        try {
            const result = await axios.delete(URL);
            callback();
            dispatch(slice.actions.deleteSuccess(result.data.data));
        } catch (error) {
            errcallback();
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function editGym(id, data, callback = () => {}, errCallback = () => {}) {
    return async () => {
        try {
            const result = await axios.put(`/gyms/${id}`, data);
            dispatch(slice.actions.editSuccess(result?.data?.data));
            callback();
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            errCallback();
        }
    };
}


export function getGyms() {
    return async () => {
        try {
            const result = await axios.get(`/gyms?size=10000`);
            dispatch(slice.actions.getSuccess(result.data.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function setCurrentPage(page) {
    return async () => {
        dispatch(slice.actions.setCurrentPage(page));
    };
}
